import React, { Component } from 'react';
import { Button, Card, Col, Divider, Form, Input, InputNumber, message, Row, Select } from 'antd';
import { queryTaskCompletion, queryTaskInfo } from '@api/task';
import moment from 'moment';
import { BackBtn } from '@comm/BackBtn';
import TableFilesAddDel from './TableFilesAddDel';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      taskInfo: {},
      subLoading: false,
      completionStatus: 1,
      fileList: [{ id: 0 }],
      fileCount: 1,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { uuid } = this.props.params;
    this.getTaskInfo(uuid);
  }

  // 获取任务信息
  getTaskInfo = uuid => {
    queryTaskInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        res.data.attachment &&
          res.data.attachment.map(item => {
            item.id = item.uuid;
            return item;
          });
        this.setState({
          taskInfo: res.data,
          fileList: res.data.attachment.length > 0 ? res.data.attachment : [{ id: 0 }],
          completionStatus: res.data.completionStatus,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 提交任务结果
  submitTask = () => {
    const { taskInfo, completionStatus, fileList } = this.state;
    const { uuid } = this.props.params;
    const attachment = [];
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {};
        this.setState({
          subLoading: true,
        });

        params.uuid = uuid;

        if (taskInfo.aim) {
          params.actual = values.actual;
          params.fettle = completionStatus;
        } else {
          params.fettle = values.completionStatus;
        }
        fileList.map(item => {
          if (values[`name${item.id}`] && values[`files${item.id}`]) {
            attachment.push({
              name: values[`name${item.id}`],
              files: values[`files${item.id}`],
            });
          }
          return item;
        });
        params.attachment = attachment;
        params.remark = values.remark;

        queryTaskCompletion(params).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            this.setState({
              subLoading: false,
            });
            if (taskInfo.isReview === 1) {
              this.props.router.push(`/task/task_check_mine`);
            } else {
              this.props.router.go(-1);
            }
          } else {
            message.error(res.message);
            this.setState({
              subLoading: false,
            });
          }
        });
      }
    });
  };

  changeActual = value => {
    const { aim } = this.state.taskInfo;
    if (value >= aim) {
      this.setState({
        completionStatus: 2,
      });
    } else {
      this.setState({
        completionStatus: 1,
      });
    }
  };

  /** -------------------------------------设置附件模板列表开始--------------------------------*/
  // 新增一行
  addFiles = () => {
    const { fileList, fileCount } = this.state;
    fileList.push({ id: fileCount });
    this.setState({
      fileList,
      fileCount: fileCount + 1,
    });
  };

  // 删除该行
  deleteFiles = id => {
    const { fileList } = this.state;
    this.setState({
      fileList: fileList.filter(item => item.id !== id),
    });
  };

  // 文件删除
  fileRemove = file => {};

  /** -------------------------------------设置附件模板列表结束--------------------------------*/

  render() {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { taskInfo, completionStatus, fileList, subLoading } = this.state;
    // 一整行
    const ItemLayout = {
      labelCol: { span: 2 },
      wrapperCol: { span: 21 },
    };

    // 一行2等分
    const ItemLayout2 = {
      labelCol: { span: 4 },
      wrapperCol: { span: 19 },
    };

    // 一行3等分
    const ItemLayout3 = {
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
    };
    return (
      <div>
        <Row style={{ marginBottom: '15px' }}>
          <BackBtn />
          <Button
            type="primary"
            onClick={() => this.submitTask(1)}
            icon="upload"
            loading={subLoading}
          >
            提交
          </Button>
        </Row>
        <Card>
          <Row type="flex" justify="space-around" align="middle" style={{ marginBottom: '30px' }}>
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>提交任务结果</span>
          </Row>
          <Form>
            <Row>
              <Col span={12}>
                <Form.Item label="任务名称" {...ItemLayout2}>
                  {taskInfo.name}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="任务周期" {...ItemLayout2}>
                  {`${moment.unix(taskInfo.beginDate / 1000).format('YYYY-MM-DD')}至${moment
                    .unix(taskInfo.endDate / 1000)
                    .format('YYYY-MM-DD')}`}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label="任务描述" {...ItemLayout}>
              {taskInfo.remark}
            </Form.Item>
            <Divider />
            <Row>
              {taskInfo.aim ? (
                <Col span={8}>
                  <Form.Item label="任务目标" {...ItemLayout3}>
                    {taskInfo.aim}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}
              {taskInfo.aim ? (
                <Col span={8}>
                  <Form.Item label="实际数据" {...ItemLayout3}>
                    {getFieldDecorator('actual', {
                      rules: [{ required: true, message: '请填写最终数据' }],
                      initialValue: taskInfo.actual,
                    })(
                      <InputNumber
                        style={{ width: '150px' }}
                        placeholder="请输入最终数据"
                        onChange={this.changeActual}
                      />,
                    )}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}
              <Col span={8}>
                <Form.Item label="任务结果" {...ItemLayout3}>
                  {taskInfo.aim ? (
                    <span>{completionStatus === 2 ? '已完成' : '未完成'}</span>
                  ) : (
                    <div>
                      {getFieldDecorator('completionStatus', {
                        rules: [{ required: true, message: '请选择任务结果' }],
                        initialValue: `${
                          taskInfo.completionStatus ? taskInfo.completionStatus : ''
                        }`,
                      })(
                        <Select>
                          <Select.Option key="1">未完成</Select.Option>
                          <Select.Option key="2">已完成</Select.Option>
                        </Select>,
                      )}
                    </div>
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label="相关附件" {...ItemLayout}>
              {getFieldDecorator('attachment')(
                <TableFilesAddDel
                  fileList={fileList}
                  addFiles={this.addFiles}
                  deleteFiles={this.deleteFiles}
                  fileRemove={this.fileRemove}
                  {...this.props}
                />,
              )}
            </Form.Item>
            <Form.Item label="备注说明" {...ItemLayout}>
              {getFieldDecorator('remark', {
                initialValue: taskInfo.completionRemark,
              })(
                <Input.TextArea
                  placeholder="请输入备注"
                  type="textarea"
                  autosize={{ minRows: 3, maxRows: 9 }}
                  maxLength={5000}
                />,
              )}
              <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入5000字</span>
            </Form.Item>
          </Form>
        </Card>
      </div>
    );
  }
}

export default Form.create()(Page);



// WEBPACK FOOTER //
// ./src/components/task/spTask/PageSubmit.js